import React, { useState, useEffect } from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
} from "reactstrap"
import axios from "axios"
import { getCurrentUser } from "../../../helpers/Utils"
import { toast } from "react-toastify"

const GroupModal = ({
  modal_standard,
  setmodal_standard,
  getAllGroups,
  selectedGroup,
  setSelectedGroup,
  openAssignUsersModal,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  })
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})

  useEffect(() => {
    if (selectedGroup) {
      setFormData({
        name: selectedGroup.name || "",
        description: selectedGroup.description || "",
      })
    } else {
      setFormData({
        name: "",
        description: "",
      })
    }
  }, [selectedGroup])

  const handleInputChange = e => {
    const { name, value, type, checked } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }))

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: "",
      }))
    }
  }

  const validateForm = () => {
    const newErrors = {}

    if (!formData.name.trim()) {
      newErrors.name = "Group name is required"
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = () => {
    if (!validateForm()) {
      return
    }

    setLoading(true)

    const url = selectedGroup
      ? `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/groups/${selectedGroup.id}`
      : `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/groups`

    const method = selectedGroup ? "PUT" : "POST"

    axios({
      method,
      url,
      data: formData,
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${
          getCurrentUser().token == null ? "" : getCurrentUser().token
        }`,
      },
    })
      .then(function (res) {
        setLoading(false)
        if (res.data.success) {
          toast.success(
            selectedGroup
              ? "Group updated successfully"
              : "Group created successfully",
            {
              position: "top-center",
              autoClose: 3000,
            }
          )
          setmodal_standard(false)
          setSelectedGroup(null)
          getAllGroups()

          // If it's a new group creation, open assign users modal
          if (!selectedGroup && openAssignUsersModal && res.data.data) {
            openAssignUsersModal(res.data.data)
          }
        } else {
          if (res.data.errors) {
            setErrors(res.data.errors)
          } else {
            toast.error(res.data.message, {
              position: "top-center",
              autoClose: 5000,
            })
          }
        }
      })
      .catch(err => {
        setLoading(false)
        toast.error("Failed to save group", {
          position: "top-center",
          autoClose: 5000,
        })
      })
  }

  const toggleModal = () => {
    setmodal_standard(false)
    setSelectedGroup(null)
    setFormData({
      name: "",
      description: "",
    })
    setErrors({})
  }

  return (
    <Modal isOpen={modal_standard} toggle={toggleModal} size="lg">
      <ModalHeader toggle={toggleModal}>
        {selectedGroup ? "Edit Group" : "Create New Group"}
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Label for="name">
                Group Name <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                name="name"
                id="name"
                placeholder="Enter group name"
                value={formData.name}
                onChange={handleInputChange}
                invalid={!!errors.name}
              />
              {errors.name && (
                <div className="invalid-feedback d-block">{errors.name}</div>
              )}
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={12}>
            <FormGroup>
              <Label for="description">Description</Label>
              <Input
                type="textarea"
                name="description"
                id="description"
                placeholder="Enter group description (optional)"
                value={formData.description}
                onChange={handleInputChange}
                rows={3}
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggleModal}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? (
            <>
              <i className="fa fa-spinner fa-spin me-2"></i>
              {selectedGroup ? "Updating..." : "Creating..."}
            </>
          ) : selectedGroup ? (
            "Update Group"
          ) : (
            "Create Group"
          )}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default GroupModal
